/**
 * shrineTiles.ts — SHRINE TILE ART (BETA 22.92, Dylan's system).
 *
 * Dylan hand-made 26 evergreen shrine sigil tiles (icon + baked stat label,
 * with a clean DYNAMIC VALUE ZONE in the center for code-drawn numbers). Each
 * tile maps to one shrine stat (SHRINE_BUFF_POOL.stat in itemsAdapter). The
 * shrine choice screen renders the matched tile like a perk card and draws the
 * buff value into the value zone.
 *
 * Tile files: client/public/shrine-tiles/<stat>.webp  (named by stat key).
 * "Space to add the buff in them" = TILE_VALUE_ZONE below.
 */

/** Every shrine stat that has a hand-made tile (== SHRINE_BUFF_POOL.stat keys,
 *  confirmed against shrine_tiles_mapping.csv). */
export const SHRINE_TILE_STATS: ReadonlySet<string> = new Set([
  'damageBonus', 'attackSpeedBonus', 'critChance', 'critDamage', 'eliteDamageBonus',
  'knockbackBonus', 'projectileCountBonus', 'projectileBounces', 'rangeBonus',
  'maxHp', 'hpRegen', 'armor', 'evasion', 'maxShield', 'maxShieldMult',
  'shieldRegen', 'lifesteal', 'thorns', 'moveSpeed', 'dashRecharge',
  'dashDuration', 'pickupRange', 'luck', 'xpMultiplier', 'goldMultiplier',
  'difficulty',
]);

/** Tile art path for a shrine stat, or null if that stat has no tile (falls
 *  back to the code-drawn look in the renderer). */
export function shrineTilePath(stat: string | undefined): string | null {
  if (!stat || !SHRINE_TILE_STATS.has(stat)) return null;
  return `/shrine-tiles/${stat}.webp`;
}

/**
 * DYNAMIC VALUE ZONE (fractions of the square tile) — the clean center-lower
 * area Dylan kept empty for the code-drawn value. Per his spec: ~50–68% of
 * tile height, centered, ≥45% wide. The renderer centers the value string
 * here and fits the font to this box.
 */
export const TILE_VALUE_ZONE = {
  cx: 0.500,
  cy: 0.592,
  maxW: 0.62,
  maxH: 0.150,
} as const;
